import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import PatientsList from "../pages/Patients/PatientsList";
import PatientDetailPage from "../pages/Patients/PatientDetail";
import useFeatureFlags from "../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import { useEffect } from "react";
import dataConstants from "../constants/dataConstants";

function PatientsPageRoutes(): JSX.Element {
  const match = useRouteMatch();
  const history = useHistory();
  const { isSectionActive } = useFeatureFlags()

  useEffect(() => {
    if (!isSectionActive(dataConstants.FeatureFlagSectionKeys.PATIENTS)) {
      history.push('/unauthorized')
    }
  }, [isSectionActive])

  return (
    <Switch>
      <Route path={match.path} exact component={PatientsList} />
      <Route path={`${match.path}/:id`} exact component={PatientDetailPage} />
    </Switch>
  );
}

export default PatientsPageRoutes;
